import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from '../../components/navigation/StepControlButton'
import PriceListingRow from "../../components/PriceListingRow";
import {configurationScrollProgress} from "../../actions/UserInterface";
import {
    APP_MODE_AGENCYSERVER_ADD_PROJECT,
    APP_MODE_AUTHENTICATED_ORDER,
    APP_MODE_OUTSOURCING,
    APP_MODE_PRESET,
    APP_MODE_PRODUCT_CHANGE,
    APP_MODE_REGULAR,
    ARTICLE_CONFIGURATOR_MODE_CONSUMER,
    ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION,
    ARTICLE_CONFIGURATOR_MODE_SHARED
} from "../../constants/General";
import TestingGroup from "./TestingGroup";
import {forceValidationOnSteps} from "../../actions/StepControl";
import * as StepLabels from "../../constants/StepLabels";
import HintWrapper from "../../components/HintWrapper";
import {isAgencyServer, isConfigurableArticle, isNextcloudArticle} from "../../selectors/ArticleNumbers";
import {isMode} from "../../selectors/Mode";
import {getBaseArticle, getCartAllowedForCustomerChange} from "../../selectors/SimpleSelectors";
import {isConfigurationStepValid} from "../../selectors/StepValidation";
import {activateBaseArticle, loadBaseArticleData} from "../../actions/BaseArticle";
import {isBaseArticleDataLoaded} from "../../selectors/ProductSelection";
import AppPreloader from "../../components/AppPreloader";
import {delve} from "../../util/util";
import AffiliateToggleForm from "../clientdata/AffiliateToggleForm";
import {getCartSummary} from "../../selectors/Cart";
import ArticleConfigurator from "./configurator/ArticleConfigurator";
import {isExistingUserAuthenticatedAndSelected} from "../../selectors/UserInterface";
import {queryBaseArticle} from "../../actions/ArticleData";

class ConfigurationStep extends Component {

    static propTypes = {
        stepLabel: PropTypes.string.isRequired,
        nextLabel: PropTypes.string.isRequired,
        prevLabel: PropTypes.string.isRequired,
        onButtonNextClick: PropTypes.func,
        onButtonPrevClick: PropTypes.func
    }

    constructor(props) {
        super(props)
        this.state = {
            scrollBreakpoints: [],
            scrollTimeout: false
        }
    }

    handleButtonNextClick = (e) => {
        if (!this.props.configurationStepValid) {
            this.props.forceValidation()
        }
        if (this.props.configurationStepValid) {
            this.props.onButtonNextClick()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.cartIsSwappingProgress) {
            return false
        }

        // no update neccessary
        if (this.state.scrollBreakpoints !== nextState.scrollBreakpoints) {
            return false
        }
        // no update neccessary
        if (this.state.scrollTimeout !== nextState.scrollTimeout) {
            return false
        }
        return true
    }

    handleScroll = (e) => {
        if (this.state.scrollTimeout) {
            return
        }
        this.setState({
            scrollTimeout: setTimeout((e) => {
                this.setState({
                    scrollTimeout: false
                })
            }, 100)
        })
        let currentProgress = 0
        const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
        this.state.scrollBreakpoints.forEach((breakpoint) => {
            if (window.scrollY + windowHeight > breakpoint + 200) {
                currentProgress++
            }
        })
        if (this.props.configurationScrollProgress !== currentProgress) {
            this.props.queryConfigurationScrollProgress(currentProgress / this.state.scrollBreakpoints.length)
        }
    }

    componentDidMount() {
        let scrollBreakpoints = []
        window.addEventListener('scroll', this.handleScroll)
        this.setState({
            scrollBreakpoints: scrollBreakpoints
        })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    render() {

        if (!this.props.baseArticleData) {
            return <div
                className="step-display__page configuration-step"
                style={{"minHeight": 1000}}
            ><AppPreloader label={""}/></div>
        }

        if (!this.props.baseArticleDataLoaded) {
            return <div
                className="step-display__page configuration-step"
                style={{"minHeight": 1000}}
            ><AppPreloader label={""}/></div>
        }

        let validationError = null;

        const forceValidation = !this.props.configurationStepValid && this.props.forcedValidationSteps.includes(StepLabels.CONFIG)
        const hidePersonalization = !(this.props.isAgencyServerAddProjectMode || this.props.isRegularMode || this.props.isAuthenticatedOrderMode || this.props.isPresetMode);

        if (forceValidation) {
            validationError = <HintWrapper
                content={"Bitte konfiguriere dein Projekt, bevor du fortfährst."}
                theme="error"
            />
        }

        const showSoftwareGroup = !this.props.isNextcloudArticle &&
            !isMode(APP_MODE_PRODUCT_CHANGE) &&
            !this.props.baseArticleHasSourceIdentifier &&
            (this.props.baseArticleData.type === 'vserver' || this.props.baseArticleData.type === 'server');

        let introText = 'Deine zuvor getroffene Tarifauswahl haben wir für dich übernommen. Du kannst natürlich jederzeit zurückspringen und einen anderen Tarif auswählen.';

        if (isMode(APP_MODE_PRESET)) {
            introText = 'Die Tarifwahl für die Übertragung deines Projektes haben wir übernommen. Nachfolgend kannst du dieses personalisieren und bei Bedarf Tarifparameter anpassen.'
        }

        return (
            <div className="step-display__page configuration-step">

                {validationError}

                {this.props.isRegularMode && this.props.baseArticleData && this.props.baseArticleData.type !== 'vserver' ? <div className={"configuration-step__base"}>
                    <h1>Dein Tarif</h1>
                    <PriceListingRow
                        title={this.props.baseArticleData.title}
                        caption={this.props.baseArticleData.description}
                        monthly={delve(this.props.baseArticleData, "billing.billingPeriod") !== 0}
                        price={Number(this.props.cartSummary.baseArticle.priceMonthly).toFixed(2) + " €"}
                        tax={true}
                    />
                    {this.props.cartSummary.baseArticle.setupFee > 0 ? <PriceListingRow
                        title={"Einrichtungsgebühr"}
                        caption={"einmalig"}
                        price={Number(this.props.cartSummary.baseArticle.setupFee).toFixed(2) + " €"}
                        tax={true}
                    /> : null}
                </div> : null}

                {
                    this.props.isAgencyServer ?
                        <div className="configuration-step__custom-group">
                            <h2>Projekt-Konfigurator</h2>
                            <p>Zahle nur, was du brauchst! Dein Agentur-Server wächst mit jedem Projekt.</p>
                            <ArticleConfigurator
                                forceValidation={forceValidation}
                                mode={ARTICLE_CONFIGURATOR_MODE_SHARED}
                                // only show for 3 modes
                                hidePersonalization={hidePersonalization}
                            />
                        </div>
                        : (this.props.isConfigurableArticle || isMode(APP_MODE_AUTHENTICATED_ORDER)) ?
                            <div className="configuration-step__custom-group">
                                <h2>Tarif-Konfigurator</h2>
                                <p>{introText}</p>
                                {isMode(APP_MODE_PRESET) ?
                                    <HintWrapper
                                        theme="blue"
                                        content={"Bitte beachte, dass dieses Projekt bereits jetzt kostenpflichtige Zusatzartikel wie z. B. Domains, SSL-Zertifikate oder Software Add-Ons beinhalten kann, die hier nicht explizit aufgeführt werden. Sie werden dennoch automatisch mit übertragen. Unser Kundenservice unterstützt dich hier gerne, wenn du eine detaillierte Auflistung aller Artikel benötigst, die zu diesem Projekt gehören."}
                                    /> : null}
                                <ArticleConfigurator
                                    mode={isMode(APP_MODE_AUTHENTICATED_ORDER) ? ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION : ARTICLE_CONFIGURATOR_MODE_CONSUMER}
                                    hideStorage={this.props.baseArticleData.type !== 'vserver'}
                                    hideBackup={this.props.baseArticleData.type !== 'vserver'}
                                    hidePersonalization={hidePersonalization}
                                    hideSoftware={!showSoftwareGroup}
                                    isStandaloneProduct={true}
                                />
                            </div>
                            : null
                }

                {this.props.isAllowedForCustomerChange && !isMode(APP_MODE_OUTSOURCING) && !isMode(APP_MODE_PRESET) ? <AffiliateToggleForm/> : null}

                {
                    !this.props.isNextcloudArticle &&
                    !isMode(APP_MODE_PRODUCT_CHANGE) &&
                    !isMode(APP_MODE_AUTHENTICATED_ORDER) &&
                    !this.props.baseArticleHasSourceIdentifier &&
                    !this.props.iseUserAuthenticatedAndSelected &&
                    this.props.baseArticleData.isTestable ?
                        <TestingGroup/>
                        : null
                }

                <div className="step-display__page__control">
                    {this.props.prevLabel !== "" ? <StepControlButton
                        type={CONTROL_PREV}
                        label={this.props.prevLabel}
                        onClick={this.props.onButtonPrevClick}
                    /> : null}
                    {this.props.nextLabel !== "" ? <StepControlButton
                        disabled={!this.props.configurationStepValid}
                        type={CONTROL_NEXT}
                        label={this.props.nextLabel}
                        onClick={this.handleButtonNextClick}
                    /> : null}
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {

    if (!state.articleData.baseArticle) {
        return {}
    }

    return {
        forcedValidationSteps: state.ui.forcedValidationSteps,
        baseArticleData: getBaseArticle(state),
        cartSummary: getCartSummary(state),
        configurationScrollProgress: state.ui.configurationScrollProgress,
        isAgencyServerAddProjectMode: isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT),
        isRegularMode: isMode(APP_MODE_REGULAR),
        isPresetMode: isMode(APP_MODE_PRESET),
        isAuthenticatedOrderMode: isMode(APP_MODE_AUTHENTICATED_ORDER),
        configurationStepValid: isConfigurationStepValid(state),
        isAgencyServer: isAgencyServer(getBaseArticle(state).articleNumber),
        isConfigurableArticle: isConfigurableArticle(getBaseArticle(state).articleNumber),
        isNextcloudArticle: isNextcloudArticle(getBaseArticle(state).articleNumber),
        baseArticleDataLoaded: isBaseArticleDataLoaded(state),
        baseArticleHasSourceIdentifier: delve(state, "cart.sourceAccount"),
        cartIsSwapping: state.cart.isSwapping,
        cartIsSwappingProgress: state.cart.isSwappingProgress,
        isAllowedForCustomerChange: getCartAllowedForCustomerChange(state),
        iseUserAuthenticatedAndSelected: isExistingUserAuthenticatedAndSelected(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        queryConfigurationScrollProgress: (num) => {
            dispatch(configurationScrollProgress(num))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ConfigurationStep)



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/ConfigurationStep.js
 **/